import * as React from 'react';
import { AdfoxContextProvider, TAdfoxContextProviderProps } from '../../context/AdfoxContext';
import { AdfoxBannerContainer } from '../../../AdfoxBannerContainer';

const POST_VIEW_ANALYTICS_DATA: TAdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'footer',
};
const P_PARAMS: TAdfoxContextProviderProps['pParams'] = { p1: 'dbtyp', p2: 'y' };
const SIZE: TAdfoxContextProviderProps['size'] = { width: '100%', height: 560 };

export const AdfoxBannerFooterDesktop = React.memo(function AdfoxBannerMainPageFooter() {
  return (
    <AdfoxContextProvider postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA} size={SIZE} pParams={P_PARAMS}>
      {() => <AdfoxBannerContainer />}
    </AdfoxContextProvider>
  );
});
